export default "__VITE_ASSET__b32fb0a0__"